module.exports = __webpack_public_path__ + "media/images/icons/flags/LA-77c1553ddab8517b08547aaf74faac34.svg";